import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useLang } from '../../i18n/LangContext';

const TXT = {
  es: ['Tu cuenta de administrador debe activar el doble factor', (d) => ` (quedan ${d} días)`, 'Activar ahora'],
  pt: ['Sua conta de administrador deve ativar a autenticação em dois fatores', (d) => ` (restam ${d} dias)`, 'Ativar agora'],
  en: ['Your administrator account must enable two-factor authentication', (d) => ` (${d} days left)`, 'Enable now'],
};

export const MfaBanner = ({ graceUntil }) => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  if (pathname === '/seguridad') return null;
  const days = graceUntil ? Math.max(0, Math.ceil((new Date(graceUntil) - new Date()) / 86400000)) : null;
  const [msg, left, cta] = TXT[lang] || TXT.es;
  return (
    <div className="bg-amber-500/15 border-b border-amber-500/30 text-amber-200 text-sm px-4 py-2 flex flex-wrap items-center justify-center gap-2" data-testid="mfa-admin-banner">
      <ShieldAlert className="w-4 h-4" />
      {msg}{days !== null ? left(days) : ''}.
      <Link to="/seguridad" className="underline font-semibold" data-testid="mfa-banner-link">{cta}</Link>
    </div>
  );
};
